import axios from "axios";
import { getToken } from "./auth";

// Use env var REACT_APP_API_BASE_URL if present, otherwise fallback to empty string
const baseURL = process.env.REACT_APP_API_BASE_URL || "";

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach auth token from cookie to every request automatically
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
